import { MessageBox, MessageBoxStatus } from "@yy/tofu-ui-react";
import React from "react";

// 已经成功成为普通公会
export const showBeNormalGuildSuccessDialog = () => {
  MessageBox({
    width: "400px",
    title: "恭喜您成为普通公会",
    status: MessageBoxStatus.SUCCESS,
    showCancel: false,
    okTxt: "公会管理中心",
    rootClassName: "beNormal-success-messagebox-root",
    desc: (
      <div className="beNormal-success-messagebox">
        <br />
        <br />
      </div>
    ),
    onOk: () => {
      window.location.href = "//www.yy.com/gi/";
      return true;
    },
  });
};

// 已经成功成为星级公会
export const showBeStarGuildSuccessDialog = (depositFlag: boolean) => {
  MessageBox({
    rootClassName: "beStar-success-messagebox-root",
    width: "400px",
    title: "恭喜您成为星级公会",
    status: MessageBoxStatus.SUCCESS,
    showCancel: false,
    okTxt: "公会管理中心",
    desc: (
      <div className="beStar-success-messagebox">
        {depositFlag && (
          <p className="desposit-hint">
            累积冻结您3000元公会保证金；若公会降为普通公会，保证金会解冻至您YY保证金账户。
          </p>
        )}

        <p className="ul-hint">进入公会管理中心可：</p>
        <ul>
          <li>设置公会名，防冒充</li>
          <li>领取星级公会资源包</li>
          <li>邀请未绑定主播快捷通道</li>
          <li>学习公会成长课程</li>
        </ul>
      </div>
    ),
    onOk: () => {
      window.location.href = "//www.yy.com/gi/";
      return true;
    },
  });
};
